/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesnav1Inputs */

const en_opportunitiesnav1 = /** @type {(inputs: Opportunitiesnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunities`)
};

const de_opportunitiesnav1 = /** @type {(inputs: Opportunitiesnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chancen`)
};

/**
* | output |
* | --- |
* | "Opportunities" |
*
* @param {Opportunitiesnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesnav1 = /** @type {((inputs?: Opportunitiesnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesnav1(inputs)
	return de_opportunitiesnav1(inputs)
});
export { opportunitiesnav1 as "opportunitiesNav" }